import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Waves, Sun, Anchor, MapPin } from "lucide-react";
const serviceLocations = [{
  name: "Gorokan",
  icon: Waves
}, {
  name: "Toukley",
  icon: Sun
}, {
  name: "Norah Head",
  icon: Anchor
}, {
  name: "Gwandalan",
  icon: Waves
}, {
  name: "Budgewoi",
  icon: Sun
}, {
  name: "Lake Haven",
  icon: Waves
}, {
  name: "Charmhaven",
  icon: Sun
}, {
  name: "Gosford",
  icon: MapPin
}, {
  name: "Central Coast",
  icon: Waves
}, {
  name: "Lake Macquarie",
  icon: Anchor
}, {
  name: "Newcastle",
  icon: MapPin
}, {
  name: "Surrounding Suburbs",
  icon: MapPin
}];
export default function ServiceAreas() {
  return <section id="service-areas" className="relative py-16 md:py-24 bg-muted/40 overflow-hidden">
      {}
      <div className="absolute top-0 right-0 -mt-16 -mr-16 text-primary/5 pointer-events-none">
        <Waves className="w-64 h-64" />
      </div>
      <div className="absolute bottom-0 left-0 -mb-16 -ml-16 text-accent/5 pointer-events-none">
        <Sun className="w-64 h-64" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4 tracking-tight">
            Our Service Areas
          </h2>
          <p className="text-lg text-muted-foreground">
            Proudly providing top-quality residential and industrial painting services across the Northern Central Coast NSW.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {serviceLocations.map((location, index) => {
          const Icon = location.icon;
          return <Card key={location.name} data-index={index} className="group bg-background border-border/50 shadow-sm hover:shadow-md hover:border-accent/40 transition-all duration-300 hover:-translate-y-1">
                <CardContent className="p-6 flex flex-col items-center justify-center text-center h-full gap-4">
                  <div className="p-3 rounded-full bg-muted/50 text-primary group-hover:bg-accent/10 group-hover:text-accent transition-colors duration-300">
                    <Icon className="w-6 h-6" strokeWidth={1.5} />
                  </div>
                  <h3 className="font-medium text-foreground text-base md:text-lg">
                    {location.name}
                  </h3>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}